export const bannersList = getters => {
  return getters.bannersList
}

export const getManagingBanner = getters => {
  return getters.manageBanner
}
